export const lang = [
  { name: "繁體中文", lang: "zh-TW" },
  { name: "简体中文", lang: "zh-CN" },
  { name: "English", lang: "en" },
];

export const tab = [
  { name: "About", action: "homeTop" },
  { name: "Product", to: "/product", type: "route" },
  { name: "News", to: "/news", type: "route" },
  { name: "Institute", to: "/institute", type: "route" },
  { name: "Member", to: "/member", type: "route" },
  { name: "Contact", to: "#contact", type: "anchor" },
];